import React, { useEffect, useState } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { useDeviceDetection } from "./hooks/useDeviceDetection";

import { MobileSplash } from "./components/MobileSplash";
import { PriceCards } from "./components/PriceCards";
import { CoffeeNews } from "./components/CoffeeNews";
import { Footer } from "./components/Footer";
import { SimpleHeader } from "./components/SimpleHeader";

const LandingPage = () => {
  return (
    <div className="min-h-screen bg-background-dark">
      <SimpleHeader />

      <main className="pt-2">
        <section id="prices">
          <PriceCards />
        </section>

        <section id="news">
          <CoffeeNews />
        </section>
      </main>

      <Footer />
    </div>
  );
};

const AppContent = () => {
  const { isMobile, isLoading } = useDeviceDetection();
  const [showSplash, setShowSplash] = useState(false);
  const [hasSeenSplash, setHasSeenSplash] = useState(false);

  useEffect(() => {
    let seenSplash = null;

    try {
      seenSplash = localStorage.getItem("coffee-market-splash-seen");
    } catch (error) {
      seenSplash = "true";
    }

    if (!isLoading) {
      if (isMobile && !seenSplash) {
        setShowSplash(true);
        setHasSeenSplash(false);
      } else {
        setShowSplash(false);
        setHasSeenSplash(true);
      }
    }
  }, [isMobile, isLoading]);

  const handleEnterApp = () => {
    setShowSplash(false);
    setHasSeenSplash(true);

    try {
      localStorage.setItem("coffee-market-splash-seen", "true");
    } catch (error) {
      // Continua normalmente se o navegador bloquear o armazenamento local.
    }
  };

  if (isLoading) {
    return (
      <div className="fixed inset-0 bg-background-dark flex items-center justify-center">
        <div className="text-primary-text text-lg">Carregando...</div>
      </div>
    );
  }

  if (showSplash && isMobile && !hasSeenSplash) {
    return <MobileSplash onEnter={handleEnterApp} />;
  }

  return <LandingPage />;
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<AppContent />} />
          <Route path="/home" element={<LandingPage />} />
          <Route path="*" element={<LandingPage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
